import * as am4charts from "@amcharts/amcharts4/charts";

import * as am4core from "@amcharts/amcharts4/core";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";
import CircularProgress from "@material-ui/core/es/CircularProgress/CircularProgress";
import React, {Component} from "react";
import * as API from "../util/api";
import * as Render from "../util/Render";

am4core.useTheme(am4themes_animated);
am4core.options.commercialLicense = true;

const makeGraph = (data, name, unit, color, ref) => {
    let chart = am4core.create(ref.current, am4charts.XYChart);

    chart.paddingRight = 20;
    chart.colors.list = [am4core.color(color)];

    let dateAxis = chart.xAxes.push(new am4charts.DateAxis());
    dateAxis.renderer.grid.template.location = 0;

    dateAxis.dateFormats.setKey("hour", "dd MMM HH:mm");
    dateAxis.periodChangeDateFormats.setKey("hour", "dd MMM HH:mm");
    dateAxis.dateFormats.setKey("minute", "dd MMM HH:mm");
    dateAxis.periodChangeDateFormats.setKey("minute", "dd MMM HH:mm");
    dateAxis.dateFormats.setKey("day", "dd MMM yyyy");
    dateAxis.periodChangeDateFormats.setKey("day", "dd MMM yyyy");
    dateAxis.dateFormats.setKey("week", "dd MMM yyyy");
    dateAxis.periodChangeDateFormats.setKey("week", "dd MMM yyyy");
    dateAxis.dateFormats.setKey("month", "MMM yyyy");
    dateAxis.periodChangeDateFormats.setKey("month", "MMM yyyy");

    let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
    valueAxis.tooltip.disabled = true;
    valueAxis.title.text = `${name} (${unit})`;

    let series = chart.series.push(new am4charts.LineSeries());
    series.dataFields.dateX = "date";
    series.dataFields.valueY = "value";
    series.name = name;
    series.tooltipText = "{valueY.value}" + unit;

    chart.cursor = new am4charts.XYCursor();

    let scrollbarX = new am4charts.XYChartScrollbar();
    scrollbarX.series.push(series);
    chart.scrollbarX = scrollbarX;
    chart.exporting.menu = new am4core.ExportMenu();
    chart.exporting.filePrefix = name;
    chart.legend = new am4charts.Legend();

    chart.data = data;
};


export default class PopupPowerGraph extends Component {

    constructor() {
        super();
        this.graphRef1 = React.createRef();
        this.graphRef2 = React.createRef();
        this.graphRef3 = React.createRef();
        this.state = {loaded: false};
    }

    componentDidMount() {
        this.load();
    }

    load = () => {
        API.POST("systems/getSolarPowerData", {camera_id: this.props.camera_id}, result => {
            if (result.success) {
                this.setState(result.result, this.loadGraph);
            }
        });
    };

    loadGraph = () => {
        makeGraph(this.state.data.map(datum => ({
            date: new Date(datum.timestamp * 1000),
            name: "",
            value: datum.solarVolts
        })), "Solar Volts", "V", "#0288D1", this.graphRef1);

        makeGraph(this.state.data.map(datum => ({
            date: new Date(datum.timestamp * 1000),
            name: "",
            value: datum.batteryVolts
        })), "Battery Volts", "V", "#E64A19", this.graphRef2);

        makeGraph(this.state.data.map(datum => ({
            date: new Date(datum.timestamp * 1000),
            name: "",
            value: datum.chargeCurrent
        })), "Charge Current", "mA", "#4CAF50", this.graphRef3);


        this.setState({loaded: true});
    };

    render() {
        const graphHeight = 400;
        let f = Render.rawOverlay(<div style={{
            height: "calc(100vh - 80px)",
            width: "calc(100vw - 100px)",
            background: "white",
            border: "4px solid " + window.primary,
            borderRadius: 16,
            display: "flex",
            flexDirection: "column",
            position: "relative",
            overflowY: "auto"
        }}>
            <div style={{display: "flex", padding: "0px 16px", alignItems: "center"}} className="vl-theme">
                <h2 style={{flex: 1}}>{!this.state.loaded ? "Loading..." : "Power Graph"}</h2>
                <i style={{fontSize: 36}} className="material-icons hoverable" onClick={() => this.props.close()}>clear</i>
            </div>
            {!this.state.loaded &&
            <div style={{height: 600, width: "100%", display: "flex", alignItems: "center", justifyContent: "center"}}>
                <CircularProgress style={{}} size={100} thickness={2}/>
            </div>
            }

            <div style={{flex: 1, overflowY: "auto"}}>
                <div ref={this.graphRef1} style={{height: this.state.loaded ? graphHeight : 0}}/>
                <div ref={this.graphRef2} style={{height: this.state.loaded ? graphHeight : 0}}/>
                <div ref={this.graphRef3} style={{height: this.state.loaded ? graphHeight : 0}}/>
            </div>
        </div>);


        let s = Render.rawOverlay(<div style={{height: "100vh", width: "100vw", background: "rgba(0,0,0,0.7)"}}/>);
        return [s, f];
    };


}
